import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { optnAPI } from '@api/modules/optn';
import { cloneDeep } from 'lodash';
export default {
  name: 'SmplEditPrcsChild',
  props: {
    smplForm: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectionsList: [],
      crtfTypeGroupOpt: [],
      flag: true,
      semiprodOption: [],
      tableData: [],
      smpl_semiprod_list: []
    };
  },
  watch: {
    'smplForm.smpl_cut_list': function smplFormSmpl_cut_list(newValue, oldValue) {
      console.log(newValue);
      this.getSemiprodOptions();
    }
  },
  methods: {
    initData: function initData() {// this.getCrtfType()
    },
    getSemiprodOptions: function getSemiprodOptions() {
      var semiprodOptions = Array.from(this.smplForm.smpl_cut_list, function (_ref) {
        var mtrl_name = _ref.mtrl_name,
            smpl_mtrl_id = _ref.smpl_mtrl_id;
        return {
          mtrl_no: '' + mtrl_name,
          smpl_mtrl_id: smpl_mtrl_id
        };
      });
      this.semiprodOption = [];
      this.semiprodOption = semiprodOptions;
    },
    // 获取单位
    getCrtfType: function getCrtfType() {
      var _this = this;

      get(optnAPI.getAllContent, {
        perm_id: 10002
      }).then(function (res) {
        if (res.data.code === 0) {
          _this.crtfTypeGroupOpt = res.data.data;
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this.$message({
            message: mg,
            type: tp
          });
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this.$message({
          message: mg,
          type: tp
        });
      });
    },
    // 物料编号重复
    mtrlNoChange: function mtrlNoChange(scope) {
      var mtrlFlag = 0;

      for (var i = 0; i < this.smplForm.smpl_semiprod_list.length; i++) {
        if (this.smplForm.smpl_semiprod_list[i].mtrl_no === scope.row.mtrl_no) {
          mtrlFlag += 1;
        }
      }

      if (mtrlFlag > 1) {
        scope.row.mtrl_no = null;
        this.$message.error('物料编号重复，请重新填写！');
      } else {
        this.$emit('semiprodChangeCut', scope);
      }
    },
    // 下拉框回显
    semiprodChange: function semiprodChange(val, index) {
      this.smpl_semiprod_list[index]['smpl_parent_ids'] = val.join(',');
    },
    //prcs清单选择框
    handleSelectionChange1: function handleSelectionChange1(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
      this.$emit('handleSelectChangeSemiprod', this.selectionsList);
    }
  }
};